import BLCRemodal from './BLCRemodal';
import remodalEventBus from './remodalEventBus';

export default BLCRemodal;

export { remodalEventBus };
